import React from 'react';
import '../QuienesSomos/QuienesSomos.css';
import '../CatedraOMC/CatedraOMC.css';
import { Link } from 'react-router-dom';
import PageBanner from '../../layout/PageBanner';
import Card from '../CatedraOMC/Card';
import CardInvestigaciones from './CardInvestigaciones';

const PropiedadIntelectual = (props) => (
  <div >
    <PageBanner title="Propiedad Intelectual" img="banner-prop-int.jpeg">
      <Link to="/">Home</Link>
      <Link to="/propiedad-intelectual">Propiedad Intelectual</Link>
    </PageBanner>

    <section className="about-ds">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Propiedad</span> Intelectual</h2>
            </div>
            <p className="fade-in" dangerouslySetInnerHTML={{ __html: props.textPropInt }}></p>
          </div>
          <div className="col-md-5 col-sm-6 about-ds-image">
            <img src={props.imageCatedra} alt="" className="img-responsive" />
          </div>
        </div>
      </div>
    </section>

    <section className="all-course-wrapper courses-11">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Maestría/Diploma superior</span></h2>
            </div>
          </div>
          <div className="col-md-12">
            <div className="course11-blocks">
              <div className="row">
                {props.cursosPI.length > 0 &&
                  props.cursosPI.map((card, index) =>
                    <Card
                      mainState={card}
                      type='pi'
                      fromTitle="Propiedad Intelectual"
                      fromLink="/propiedad-intelectual"
                      key={`card${index}`}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Cursos y seminarios de posgrado</span></h2>
            </div>
          </div>

          {/* FEBRERO */}
          <div className="col-sm-7 event-info">
            <h3>Inicio en febrero</h3>
          </div>
          {props.cursosCSP_feb.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.cursosCSP_feb.length > 0 &&
                    props.cursosCSP_feb.map((card, index) =>
                      <Card
                        mainState={card}
                        type='pi'
                        fromTitle="Propiedad Intelectual"
                        fromLink="/propiedad-intelectual"
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.cursosCSP_feb.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>No hay cursos que inicien este mes</h4>
            </div>
          }

          {/* ABRIL - los datos siguen siendo de marzo */}
          <div className="col-sm-7 event-info">
            <h3>Inicio en abril</h3>
          </div>
          {props.cursosCSP_abr.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.cursosCSP_abr.length > 0 &&
                    props.cursosCSP_abr.map((card, index) =>
                      <Card
                        mainState={card}
                        type='pi'
                        fromTitle="Propiedad Intelectual"
                        fromLink="/propiedad-intelectual"
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.cursosCSP_abr.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>No hay cursos que inicien este mes</h4>
              <br />
              <br />
            </div>
          }

          {/* MAYO */}
          <div className="col-sm-7 event-info">
            <h3>Inicio en mayo</h3>
          </div>
          {props.cursosCSP_may.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.cursosCSP_may.length > 0 &&
                    props.cursosCSP_may.map((card, index) =>
                      <Card
                        mainState={card}
                        type='pi'
                        fromTitle="Propiedad Intelectual"
                        fromLink="/propiedad-intelectual"
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.cursosCSP_may.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>No hay cursos que inicien este mes</h4>
              <br />
              <br />
            </div>
          }

          {/* JULIO */}
          <div className="col-sm-7 event-info">
            <h3>Inicio en julio</h3>
          </div>
          {props.cursosCSP_jul.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.cursosCSP_jul.length > 0 &&
                    props.cursosCSP_jul.map((card, index) =>
                      <Card
                        mainState={card}
                        type='pi'
                        fromTitle="Propiedad Intelectual"
                        fromLink="/propiedad-intelectual"
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.cursosCSP_jul.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>No hay cursos que inicien este mes</h4>
              <br />
              <br />
            </div>
          }

          {/* OCTUBRE */}
          <div className="col-sm-7 event-info">
            <h3>Inicio en octubre</h3>
          </div>
          {props.cursosCSP_oct.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.cursosCSP_oct.length > 0 &&
                    props.cursosCSP_oct.map((card, index) =>
                      <Card
                        mainState={card}
                        type='pi'
                        fromTitle="Propiedad Intelectual"
                        fromLink="/propiedad-intelectual"
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.cursosCSP_oct.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>No hay cursos que inicien este mes</h4>
              <br />
              <br />
            </div>
          }

        </div>
      </div>

      <div className='container'>
        <div className="row">
          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Proyectos de investigación</span></h2>
            </div>
          </div>

          {/* Derecho de marcas */}
          <div className="col-sm-7 event-info">
            <h3>Línea de investigación: Derecho de marcas</h3>
          </div>
          {props.inv_derechosMarcas.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.inv_derechosMarcas.length > 0 &&
                    props.inv_derechosMarcas.map((card, index) =>
                      <CardInvestigaciones
                        id={card.id}
                        image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                        imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                        title={card.fields.Curso}
                        autor={card.fields.Autor || "Autor"}
                        description={card.fields.Descripcion}
                        pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.inv_derechosMarcas.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>Todavía no hay investigaciones de esta categoría para mostrar</h4>
              <br />
              <br />
            </div>
          }


          {/* Políticas publicas */}
          <div className="col-sm-7 event-info">
            <h3>Línea de investigación: Políticas publicas, innovación y propiedad intelectual</h3>
          </div>
          {props.inv_politicasPublicas.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.inv_politicasPublicas.length > 0 &&
                    props.inv_politicasPublicas.map((card, index) =>
                      <CardInvestigaciones
                        id={card.id}
                        image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                        imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                        title={card.fields.Curso}
                        autor={card.fields.Autor || "Autor"}
                        description={card.fields.Descripcion}
                        pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                        key={`card${index}`}
                      />
                    )}
                </div>
              </div>
            </div>
          }
          {props.inv_politicasPublicas.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>Todavía no hay investigaciones de esta categoría para mostrar</h4>
              <br />
              <br />
            </div>
          }


          {/* Derecho de autor */}
          <div className="col-sm-7 event-info">
            <h3>Línea de investigación: Derecho de autor, cultura digital y nuevas tecnologías</h3>
          </div>
          {props.inv_derechosAutor.length > 0 &&
            <div className="col-md-12">
              <div className="course11-blocks">
                <div className="row">
                  {props.inv_derechosAutor.map((card, index) =>
                    <CardInvestigaciones
                      id={card.id}
                      image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      title={card.fields.Curso}
                      autor={card.fields.Autor || "Autor"}
                      description={card.fields.Descripcion}
                      pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                      key={`card${index}`}
                    />
                  )}
                </div>
              </div>
            </div>
          }
          {props.inv_derechosAutor.length == 0 &&
            <div className="col-sm-7 event-info">
              <h4>Todavía no hay investigaciones de esta categoría para mostrar</h4>
              <br />
              <br />
            </div>
          }

        </div>
      </div>

    </section>
  </div>
);

export default PropiedadIntelectual;
